import { isBrowser } from './isBrowser';

const logCacheWarning = () => console.warn(`The environment doesn't support localStorage.`);

export const localCache = {
  set: (key: string, data: any) => {
    if (!isBrowser) return logCacheWarning();

    localStorage.setItem(key, JSON.stringify(data));
  },
  get: (key: string, defaultValue?: any) => {
    if (!isBrowser) {
      logCacheWarning();
      return defaultValue;
    }

    const storedValue = localStorage.getItem(key);

    return storedValue ? JSON.parse(storedValue) : defaultValue;
  },
  remove: (key: string) => {
    if (!isBrowser) return logCacheWarning();

    localStorage.remove(key);
  },
  clear: () => {
    localStorage.clear();
  }
};
